// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"5826d6ac","327":"f2d0b12c","570":"89e77e31"}[chunkId] + ".chunk.css";
};